import React, { useCallback, useState } from "react";
import DashboardCard from "../../DashboardCard";
import { useTranslation } from "react-i18next";
import { FeedTableDTA } from "../../types";
import FeedTable from "@components/Dashboard/DashboardPage/subpages/FeedPage/FeedTable";
import _ from "lodash";
import BaseSearchInput from "@reusables/BaseSearchInput";

export default function FeedPage(props: { feedData: FeedTableDTA }): JSX.Element {

    const { t } = useTranslation("", { keyPrefix: "dashboard.dashboard.stats" });

    const [searchingValue, setSearchingValue] = useState<string>();
    const searchInputDebounce = useCallback(_.debounce(setSearchingValue, 1000), [setSearchingValue]);

    return (
        <div>
            <DashboardCard
                dashboardAbility={"revenue.view"}
                title={t("feed.heading")}
                className="w-full"
                headerActions={<BaseSearchInput onSearch={searchInputDebounce}/>}
            >
                <FeedTable variant={"extended"} search={searchingValue}/>
            </DashboardCard>
        </div>
    );
}
